// @ts-ignore
import '@mux/mux-player/themes/microvideo';
export default 'microvideo';
